<template>
  <!-- Component not used. Left for better times. -->
  <v-row no-gutters>
    <v-col>
      <v-list class="py-0">
        <draggable :disabled="!isAnalysisDone" v-model="projectLayers" @change="updateLocksLayersOrder()">
          <v-list-item class="pa-0 pb-1" v-for="(layer, index) in computedLayers" :key="index" style="min-height: 30px">
            <v-list-item-action style="margin: 0 5px 0 0; align-self: start">
              <v-row no-gutters class="align-center">
                <v-col cols="6" style="margin: 0">
                  <v-checkbox
                    :disabled="!layer.has_permission || !isAnalysisDone"
                    :input-value="layer.visible"
                    @change="changeLocksLayerVisibility(layer.layer_id, !layer.visible)"
                    color="primary"
                  >
                  </v-checkbox>
                </v-col>
                <v-col cols="6" style="padding-bottom: 2px">
                  <template v-if="!layer.uniques">
                    <layer-style-preview-icon is-icon :geometry-type="layer.layerType" :layer-style="layer.style" />
                  </template>
                </v-col>
              </v-row>
            </v-list-item-action>
            <v-list-item-content>
              <v-col class="py-0">
                <v-row style="min-height: 27px">
                  <v-list-item-title
                    class="text-body-2"
                    :class="{ 'text--disabled': !layer.has_permission || !isAnalysisDone }"
                    style="text-align: left"
                  >
                    <v-tooltip bottom color="font" :disabled="layer.has_permission">
                      <template #activator="{ on }">
                        <span v-on="on">
                          {{ layer.name }}
                        </span>
                      </template>
                      {{ $i18n.t('sidebar.noLayerPermissions') }}
                    </v-tooltip>
                  </v-list-item-title>
                </v-row>
                <v-row v-if="layer.uniques">
                  <v-col class="pa-0 pt-2">
                    <v-list>
                      <v-list-item
                        class="px-0 layer-unique-class"
                        v-for="unique of layer.uniques"
                        :key="unique.value"
                        style="max-height: 30px; min-height: 0px"
                      >
                        <v-list-item-action class="mx-0 my-0 mr-1">
                          <layer-style-preview-icon is-icon :geometry-type="layer.layerType" :layer-style="unique" />
                        </v-list-item-action>
                        <v-list-item-title
                          style="text-align: left"
                          class="text-body-2"
                          :class="{ 'text--disabled': !layer.has_permission || !isAnalysisDone }"
                        >
                          {{ unique.value }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </v-col>
            </v-list-item-content>
            <v-list-item-action style="margin: 0; align-self: start">
              <v-row no-gutters class="align-center pr-2">
                <v-col cols="auto">
                  <v-btn
                    small
                    icon
                    @click="zoomToLocksLayer(layer.layer_id)"
                    :disabled="!layer.has_permission || !isAnalysisDone"
                  >
                    <v-icon color="rgba(0,0,0,0.7)" style="height: auto">mdi-fullscreen</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    small
                    icon
                    @click="setLocksLayer(layer.layer_id)"
                    :disabled="!layer.has_permission || !isAnalysisDone"
                  >
                    <v-icon color="rgba(0,0,0,0.7)"> mdi-table-large</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-action>
          </v-list-item>
        </draggable>
      </v-list>
    </v-col>
  </v-row>
</template>
<script>
import { call, get } from 'vuex-pathify';

import LayerStylePreviewIcon from '@/components/LayerStylePreviewIcon';
// Not used - import changed just in case
import draggable from 'vuedraggable-multi';

export default {
  name: 'LocksLayersList',
  components: {
    LayerStylePreviewIcon,
    draggable,
  },
  props: {
    isAnalysisDone: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cutoffLayersFilters: get('locks/cutoffLayersFilters'),
    cutoffProject: get('locks/cutoffProject'),
    computedLayers() {
      return this.cutoffProject.layers
        .filter(layer => layer.data_source_name !== 'water_watermeters')
        .map(layer => {
          return {
            ...layer,
            iconSrc: this.getStyleExternalGraphicIcon(layer.style ? layer.style.externalGraphic : null),
            color: this.getIconColor(layer.style, layer.has_permission),
            layerType: this.getLayerType(layer),
            uniques: layer.style && layer.style.uniques ? this.getUniques(layer.style.uniques) : null,
            visible: this.getIsVisible(layer),
            isActionsVisible: layer.type === 'features_layer' && layer.has_permission,
          };
        });
    },
    projectLayers: {
      get() {
        return this.cutoffProject.layers || [];
      },
      set(value) {
        this.$store.set('locks/SET_LOCKS_LAYERS_ORDER!', value);
      },
    },
  },
  methods: {
    getLayerFeatures: call('layers/getLayerFeatures'),
    async zoomToLocksLayer(id) {
      const filter = this.cutoffLayersFilters[id].filterResult;
      const r = await this.getLayerFeatures({
        layer_id: id,
        features_filter: filter,
        params: {
          with_features: false,
          with_collection_bbox: true,
          with_count: false,
          with_geometry: false,
        },
      });
      if (r.data.data.bbox) {
        this.$root.$emit('fitView', r.data.data.bbox);
      } else {
        this.$store.set('snackbar/PUSH_MESSAGE!', {
          message: this.$i18n.t('snackbar.zoomToEmptyLayer'),
        });
      }
    },
    changeLocksLayerVisibility(layerId, value) {
      this.$store.set('locks/SET_LOCKS_LAYER_VISIBILITY!', { layerId, visible: value });
      this.$root.$emit('toggleLocksLayerVisible', layerId, value);
    },
    getIconColor(style, has_permission) {
      if (!has_permission || !this.isAnalysisDone) {
        return '#bababa';
      } else {
        this.getStyleIconColor(style);
      }
    },
    getIsVisible(layer) {
      return layer.has_permission && layer.visible;
    },
    getUniques(uniques) {
      if (!uniques.values) {
        return;
      }
      return Object.keys(uniques.values).map(key => {
        const current = uniques.values[key];
        return {
          ...current,
          color: this.getIconColor(current),
          icon: current.externalGraphic && this.getStyleExternalGraphicIcon(current.externalGraphic),
        };
      });
    },
    setLocksLayer(layerId) {
      if (this.$route.params.lid === layerId) {
        this.$router.push({ name: 'failures' });
      } else {
        this.$router.push({
          name: 'cutoffLayerTable',
          params: { lid: layerId },
        });
      }
    },
    updateLocksLayersOrder() {
      this.$root.$emit('setLocksLayersOrder');
    },
  },
};
</script>
<style lang="scss" scoped>
.grey-icon {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  filter: grayscale(100%);
}
</style>
